import { Component, OnInit,  } from '@angular/core';

@Component({
  selector: 'app-home-banner',
  templateUrl: './home-banner.component.html',
  styleUrls: ['./home-banner.component.scss']
})
export class HomeBannerComponent implements OnInit {
  slideConfig: any;


  constructor() {
    this.slideConfig = {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      pauseOnHover: false,
      fade:true,
      autoplay: true
      }
   }

  ngOnInit(): void {

  }



}
